import PropTypes from "prop-types";
import { FixLater } from "types";
import { Button } from "components/Buttons/Button";

const AuthNextButton = ({ children, isDisabled, className, onClick }: FixLater) => {
  return (
    <Button size="large" type="button" disabled={isDisabled} className={className} onClick={onClick}>
      {children}
    </Button>
  );
};

AuthNextButton.defaultProps = {};

AuthNextButton.propTypes = {
  children: PropTypes.any,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default AuthNextButton;
